import { z } from 'zod';
export const createCommissionSchema = z.object({
    vendorId: z.string().uuid(),
    eventId: z.string().uuid().nullable().optional(),
    date: z.string().min(1),
    amount: z.number().min(0),
    paidAmount: z.number().min(0).optional(),
    paidDate: z.string().nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
});
export const updateCommissionSchema = z.object({
    eventId: z.string().uuid().nullable().optional(),
    date: z.string().min(1).optional(),
    amount: z.number().min(0).optional(),
    paidAmount: z.number().min(0).optional(),
    paidDate: z.string().nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
});
//# sourceMappingURL=commission.js.map